export default __webpack_public_path__ + "static/media/eng.94829dc0.png";